import styled from '@emotion/styled';
import * as React from '@emotion/react';
import { CardDetailsProps } from '../models/card-props';
import { FormattedHTMLMessage } from 'react-intl';
import { messages } from '../messages';

export function CardDetailsContainer({
  isCategoryLabel,
  categoryTypeColor,
  cardId
}: CardDetailsProps) {
  return (
    <CardDetailsRoot>
      <CardFieldsContainer>
        {isCategoryLabel && (
          <CategoryNameField categoryTypeColor={categoryTypeColor}>
            <FormattedHTMLMessage
              {...(cardId == 1
                ? { ...messages.cardCategory1 }
                : cardId == 2
                ? { ...messages.cardCategory2 }
                : { ...messages.cardCategory3 })}
            />
          </CategoryNameField>
        )}
        <HiddenElement id={'label' + cardId}>
          <FormattedHTMLMessage
            {...(cardId == 1
              ? { ...messages.cardLabel1 }
              : cardId == 2
              ? { ...messages.cardLabel2 }
              : { ...messages.cardLabel3 })}
          />
        </HiddenElement>
        <TitleField id={`title` + cardId}>
          <FormattedHTMLMessage
            {...(cardId == 1
              ? { ...messages.cardTitle1 }
              : cardId == 2
              ? { ...messages.cardTitle2 }
              : { ...messages.cardTitle3 })}
          />
        </TitleField>
        <DescriptionField id={`description` + cardId}>
          <FormattedHTMLMessage
            {...(cardId == 1
              ? { ...messages.cardDescription1 }
              : cardId == 2
              ? { ...messages.cardDescription2 }
              : { ...messages.cardDescription3 })}
          />
        </DescriptionField>
      </CardFieldsContainer>
    </CardDetailsRoot>
  );
}

export const HiddenElement = styled.div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const CardDetailsRoot = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const CardFieldsContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: inherit;
`;

export const CategoryNameField = styled.div<{ categoryTypeColor?: string }>`
  width: 100%;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  margin-bottom: 16px;
  text-transform: uppercase;
  color: ${(props) => props.categoryTypeColor};
`;

export const TitleField = styled.div`
  width: 100%;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
  font-size: 20px;
  display: block;

  @media only screen and (max-width: 1023px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const DescriptionField = styled.div`
  width: 100%;
  height: fit-content;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
`;
